import * as React from "react";
import { Package, Wrench, Users } from "lucide-react";
import { Separator } from "@/components/ui/separator";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
const features = [{
  title: "Nossa Missão",
  description: "Transformar espaços através de um design autêntico e funcional, elevando a experiência de morar e trabalhar com excelência técnica.",
  icon: Package
}, {
  title: "Nossa Visão",
  description: "Ser referência em arquitetura contemporânea, reconhecidos pela inovação estética e pelo compromisso com a sustentabilidade urbana.",
  icon: Wrench
}, {
  title: "Nossos Valores",
  description: "Ética, transparência e paixão pelo detalhe. Valorizamos a colaboração próxima com o cliente para materializar sonhos em realidade.",
  icon: Users
}];
export default function WhyRollkon() {
  return <section data-section-id="224215" id="missão-visão-e-valores" className="relative w-full py-[160px] bg-background text-foreground overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-[0.05] dark:opacity-[0.02]" style={{
      backgroundImage: `linear-gradient(to right, var(--border) 1px, transparent 1px), linear-gradient(to bottom, var(--border) 1px, transparent 1px)`,
      backgroundSize: "40px 40px"
    }} aria-hidden="true" />

      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div className="flex flex-col items-center text-center max-w-3xl mx-auto mb-12">
          <h2 className="font-default text-3xl md:text-4xl font-bold tracking-tight text-foreground mb-4">
            Propósito e Compromisso
          </h2>
          <p className="text-lg text-muted-foreground font-default">
            Conheça os pilares que sustentam nossa trajetória criativa e a dedicação que entregamos em cada projeto arquitetônico.
          </p>
        </div>

        <Separator className="mb-12 bg-border/40" />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature, i) => {
          const Icon = feature.icon;
          return <div data-index={i} key={i} className="h-full">
                <Card className="h-full bg-white border-border/90 rounded-xl shadow-sm hover:shadow-xl transition-shadow duration-300">
                  <CardHeader className="pb-4">
                    <div className="mb-4 inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-primary/5 text-primary">
                      <Icon className="w-8 h-8" strokeWidth={2} />
                    </div>
                    <CardTitle className="font-default text-2xl font-semibold text-foreground">
                      {feature.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <CardDescription className="text-base text-muted-foreground leading-relaxed font-default">
                      {feature.description}
                    </CardDescription>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}